import axios from 'axios'
import qs from 'qs'
import cartUtils from '../../modules/utils/cartUtils'
import lib from '../../library'

// const options = {
//   method: 'post',
//   url: '/',
//   headers: {
//     'Content-Type': 'application/x-www-form-urlencoded',
//     'X-CSRF-Token': window.CSRFToken,
//   },
//   data: qs.stringify(data),
// }
// axios(options)
//   .then((response) => {
//     console.log('added to cart')
//     this.updateCart(response.data.cart.totalQty)
//     this.el.classList.remove('s-loading')
//     this.handleSuccessButton()
//     cartUtils.cartOpenClose('open')
//     e.preventDefault()
//   })
//   .catch((error) => {
//     lib.logError(error)
//   })

export default ($el) =>
  ({
    el: $el,
    email: '',
    password: null,
    error: '',
    hasError: false,
    success: false,
    successUrl: '',
    csrfToken: window.CSRFToken,
    progressClass: ['s-working', 'opacity-50'],

    handleSubmit($event) {
      this.error = ''
      this.hasError = false
      const data = {
        action: 'users/login',
        loginName: this.email,
        password: this.password,
      }
      const options = {
        method: 'post',
        url: '/',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-CSRF-Token': this.csrfToken,
        },
        data: qs.stringify(data),
      }

      this.el.classList.add(...this.progressClass)
      $event.preventDefault()

      axios(options)
        .then((response) => {
          // success
          console.log(response)
          this.el.classList.remove(...this.progressClass)
          if (response.data.success) {
            this.success = true
            this.successUrl = response.data.returnUrl ?? '/'
          }
          // status 200 but error logging in
          if (response.data.error) {
            this.hasError = true
            this.error = response.data.error
          }
        })
        .catch((error) => {
          this.el.classList.remove(...this.progressClass)
          console.log(error)
          this.error = error
          // lib.logError(error)
        })
    },
  })
